import { Label } from '@lensora/ui'

import { MCP_SCOPES } from './scopes'

import type { McpApiKeyScope } from '@/hooks/use-mcp-keys'


interface ScopeChecklistProps {
  scopes: McpApiKeyScope[]
  onToggle: (scope: McpApiKeyScope) => void
}

export function ScopeChecklist({ scopes, onToggle }: ScopeChecklistProps) {
  return (
    <div className="space-y-2">
      <Label>Scopes</Label>
      <div className="space-y-2">
        {MCP_SCOPES.map((scope) => (
          <label
            key={scope.value}
            className="flex cursor-pointer items-start gap-2.5 rounded-md border border-border p-2.5 hover:bg-surface-raised"
          >
            <input
              type="checkbox"
              className="mt-0.5"
              checked={scopes.includes(scope.value)}
              onChange={() => onToggle(scope.value)}
            />
            <div>
              <p className="text-sm font-medium text-text">{scope.label}</p>
              {scope.isWrite && (
                <p className="text-xs text-text-muted">{scope.description}</p>
              )}
            </div>
          </label>
        ))}
      </div>
    </div>
  )
}
